import { render, staticRenderFns } from "./BatchCheck.vue?vue&type=template&id=4f12c006&"
import script from "./BatchCheck.vue?vue&type=script&lang=js&"
export * from "./BatchCheck.vue?vue&type=script&lang=js&"
import style0 from "./BatchCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports